import React, { useEffect, useState } from "react";
import logo from "../../../assets/img/pics/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getFromLocalStorage,
  removeAllFromLocalStorage,
} from "../../../helpers";
import AvtarDropDown from "../../../reusable/AvtarImg/Avtar";
import profile from "../../../assets/img/pics/user.png";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { BiCart } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import AddAddressModal from "../../../component/modal/AddAddressModal";
import AddressListModal from "../../../component/modal/AddressListModal";
import { useForm } from "react-hook-form";
import {
  addNewAddress,
  getAddressByUserId,
  getUserProfile,
} from "../../../api/common";
import { toast } from "react-toastify";
import { clearCartSuccess } from "../../../reducers/users/user";
const nav = [
  {
    label: "Home",
    key: "0",
    path: "/",
  },
  {
    label: "Products",
    key: "2",
    path: "/products",
  },
  // {
  //   label: "FAQ",
  //   key: "3",
  //   path: "/faq",
  // },
  {
    label: "About Us",
    key: "4",
    path: "/about-us",
  },
  {
    label: "Contact Us",
    key: "5",
    path: "/contact",
  },
  // {
  // label: "Orders",
  // key: "6",
  // path: "/user-orders",
  // },
];
const Header = () => {
  const dispatch = useDispatch();

  const {
    register,
    unregister,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    reset,
  } = useForm();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [routes, setRoutes] = useState(nav);
  const [visible, setVisible] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [userInfo, setUserInfo] = useState();

  const token = getFromLocalStorage("token");

  const navigate = useNavigate();
  const location = useLocation();
  // const { total_items } = useSelector((state) => state.cart);
  const { cart, total_items, total_amount, shipping_fee } = useSelector(
    (state) => state.cart
  );
  const { userDetail } = useSelector((state) => state.common);
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);
  // useEffect hook to update scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.pageYOffset);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const items = [
    {
      label: (
        <span
          onClick={() => navigate("/profile")}
          style={{ padding: "5px 12px" }}
        >
          Profile
        </span>
      ),
      key: "0",
    },
    {
      label: (
        <span onClick={() => setVisible(true)} style={{ padding: "5px 12px" }}>
          Address
        </span>
      ),
      key: "1",
    },
    {
      label: getFromLocalStorage("userType") === 1 && (
        <span
          onClick={() => navigate("/admin/orders")}
          style={{ padding: "5px 12px" }}
        >
          Admin Portal
        </span>
      ),
      key: "2",
    },
    {
      type: "divider",
    },
    {
      label: (
        <span onClick={() => logoutHandler()} style={{ padding: "5px 12px" }}>
          Logout
        </span>
      ),
      key: "3",
    },
  ];

  useEffect(() => {
    if (token) {
      setRoutes([
        ...routes,
        {
          label: "Orders",
          key: "6",
          path: "/user-orders",
        },
      ]);
      dispatch(getUserProfile()).catch((err) =>
        console.error(err?.returnMessage[0])
      );
    }
  }, [token]);

  const logoutHandler = () => {
    dispatch(clearCartSuccess());
    removeAllFromLocalStorage();
    navigate("/login");
    localStorage.clear();
  };
  const signInHandler = () => {
    navigate("/login");
  };

  const onFormSubmit = (data) => {
    dispatch(addNewAddress(data)).then((res) => {
      if (res.statusCode === 200) {
        toast.success("Address Added Successfully");
        setAddVisible(false);
        if (token) dispatch(getAddressByUserId());
      }
    });
  };

  const addressListHandler = () => {
    console.log("hi");
  };

  return (
    <>
      <nav
        className={` navbar navbar-expand-lg navbar-light ${
          scrollPosition > 5 ? "userNav" : "userNav_bg"
        } sticky-top `}
        // style={{position:'fixed'}}
      >
        <div className="container-fluid">
          <a className="navbar-brand cp">
            <img
              src={logo}
              onClick={() => navigate("/")}
              style={{ height: "60px", width: "106px" }}
              alt=""
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav ms-auto  mb-lg-0">
              {routes.map((item, i) => {
                return (
                  <li
                    key={i}
                    className="d-flex justify-content-center align-items-center "
                  >
                    <Link
                      to={item.path}
                      className={`${
                        location.pathname === item.path
                          ? "selected mx-3 pb-1 px-2  nav-item"
                          : " mx-3 nav-item   "
                      }`}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}

              {/* {token&&  */}
              <li className=" mx-4 cursor-pointer ">
                <Link to="/cart">
                  <span className="  position-relative">
                    <FaShoppingCart className="fs-4" />
                    <span className="position-absolute    translate-middle badge rounded-pill bg-danger">
                      {cart?.length}
                    </span>
                  </span>
                </Link>
              </li>
              {/* } */}
            </ul>
            <div className="cursor-pointer">
              {getFromLocalStorage("token") ? (
                <div className="ms-3">
                  <AvtarDropDown
                    profile={userDetail?.profileImage || profile}
                    items={items}
                  />
                </div>
              ) : (
                <span className="ms-3 fs-6" onClick={() => signInHandler()}>
                  <text className="mx-2 my-2">Sign In</text>
                </span>
              )}
            </div>
          </div>
        </div>
      </nav>
      <AddAddressModal
        visible={addVisible}
        header={"Add New Address"}
        setVisible={() => setAddVisible(false)}
        footer={false}
        register={register}
        SubmitHandler={handleSubmit(onFormSubmit)}
        errors={errors}
        setValue={setValue}
      />
      <AddressListModal
        visible={visible}
        header={"Address List"}
        setVisible={() => setVisible(false)}
        footer={false}
        btnname={"Add New Address"}
        // register={register}
        addAddressHandler={() => setAddVisible(true)}
        SubmitHandler={addressListHandler}
        errors={errors}
      />
    </>
  );
};

export default Header;
